<template>
	<div>
		<div class="mb-12">
			<v-form v-model="formIsValid">
				<!-- v-mask="maskGiftcardNumber" -->

				<v-text-field v-model="form.giftcardNumber" label="Gavekortnummer" class="prime" placeholder="Skriv inn ditt Fixit.no gavekort-nummer" :rules="rules[0]" />

				<v-text-field v-model="form.mobile" v-mask="maskMobile" label="Mobil" class="prime" placeholder="Skriv inn ditt mobilnummer" :rules="rules[1]" />
			</v-form>
		</div>
		<v-btn color="primary" depressed @click="currentStep++" :disabled="!valid">Gå videre</v-btn>
	</div>
</template>

<script>
export default {
	name: 'activate-giftcard-enter-giftcard-number',
	components: {},
	props: {
		giftcard: null,
		value: null // Current step
	},
	data() {
		return {
			validGiftCard: 0,
			formIsValid: false,
			form: {
				giftcardNumber: '',
				mobile: ''
			},
			//maskGiftcardNumber: 'P XXXX XXXX',
			maskMobile: '########'
		};
	},
	created() {
		// Allow preset giftcard number and mobile
		this.form.giftcardNumber = this.$route.query.gk || '';
		this.form.mobile = this.$route.query.m || '';
	},
	computed: {
		valid: function() {
			return this.formIsValid;
		},
		currentStep: {
			get() {
				return this.value || -1;
			},

			set(value) {
				this.$emit('input', value);
			}
		},
		rules() {
			const rules = [];
			const giftcardNumber = [v => v.length > 8 || 'Ugylding gavekortnummer. Lengde må være minst 9.'];
			const mobile = [v => v.length == 8 || 'Ugylding mobilnummer. Lengde må være 8 tegn.'];
			rules.push(giftcardNumber);
			rules.push(mobile);
			return rules;
		}
	},
	watch: {
		form: {
			deep: true,
			handler(form) {
				if (form) {
					this.$emit('update:giftcard', { ...form });
				}
			},
			immediate: true
		}
	},
	methods: {}
};
</script>

<style lang="scss" scoped></style>
